module.exports = __webpack_public_path__ + "static/api-page-1-abc2841436467883aa9baf304436f46d.png";